<template lang="pug">
  #why-choose-us
    h2.section-title Por que escolher #[strong nós?]
    .content(v-if="isMobile")
      .left-items
        .item(v-for="unique in uniquenessLeft")
          .item__content
            h4.title {{ unique.title }}
            p.description {{ unique.description }}
      .right-items
        .item(v-for="unique in uniquenessRight")
          .item__content
            h4.title {{ unique.title }}
            p.description {{ unique.description }}
      .man
    .content(v-else)
      .left-items
        .item(v-for="unique in uniquenessLeft")
          .item__content
            h4.title {{ unique.title }}
            p.description {{ unique.description }}
      .man
      .right-items
        .item(v-for="unique in uniquenessRight")
          .item__content
            h4.title {{ unique.title }}
            p.description {{ unique.description }}
</template>

<script>
export default {
  name: 'WhyChooseUs',
  data: () => ({
    uniquenessLeft: [
      {
        title: "Atendimento Personalizado",
        description: "Aqui você tem o tratamento que merece, com a qualidade que você precisa e com um preço justo.",
      },
      {
        title: "Especialistas Certificados",
        description: "Nossa equipe é altamente qualificada com experiência e certificação que garante uma qualidade de serviço no padrão Revisa Car.",
      },
      {
        title: "Suporte Customizado",
        description: "Nossa equipe é altamente treinada para oferecer o melhor atendimento e sanar todas as dúvidas que você tiver.",
      },
    ],
    uniquenessRight: [
      {
        title: "Velocidade Surpreendente",
        description: "Nossos procedimentos são resultados de muita experiência aliada à alta precisão na execução de serviços, resultando em um trabalho rápido.",
      },
      {
        title: "Compromisso com Você",
        description: "Prezamos pela opinião do cliente e trabalhamos cada vez mais para que com a sua ajuda, a Revisa Car se torne melhor ainda para você.",
      },
      {
        title: "Comodidade",
        description: "Provemos de um ambiente, amplo, confortável, limpo e seguro para você e sua família relaxarem enquanto trabalhamos em seu veículo.",
      }
    ],
    isMobile: false
  }),
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    this.handleResize()
  },
  methods: {
    handleResize() {
      let windowWidth = window.innerWidth
      if (windowWidth < 1366) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/resources'

#why-choose-us
  float left
  width 100%
  height 100%
  display flex
  flex-direction column
  background-color #F4F4F4

  .content
    float left
    width 100%
    flex 1
    display flex
    justify-content space-between

    .left-items
      .item
        display flex
        justify-content flex-end
        text-align left

        &:nth-child(2)
          background-color $revisacar-red
          color white

    .right-items
      .item
        display flex
        justify-content flex-start
        text-align right

        &:nth-child(2)
          background-color $revisacar-red
          color white

    .left-items, .right-items
      height 100%
      display flex
      flex-direction column
      justify-content center

      .item
        width 500px
        background-color white
        color black
        margin 15px 0
        padding 30px 30px
        box-sizing border-box

        .item__content
          width 80%

          .title, .description
            margin 0

          .title
            text-transform uppercase
            margin-bottom 15px

    .man
      width 550px
      height 100%
      background-image url('../assets/images/image3.png')
      background-size contain
      background-repeat no-repeat
      background-position bottom center

@media (max-width: 1366px)
  #why-choose-us
    height auto

    .content
      flex-direction column

      .left-items
        .item
          justify-content flex-start
          text-align left

          &:nth-child(2)
            background-color $revisacar-red
            color white

      .right-items
        .item
          justify-content flex-start
          text-align left

          &:nth-child(1), &:nth-child(3)
            background-color $revisacar-red
            color white

          &:nth-child(2)
            background-color white
            color black

      .left-items, .right-items

        .item
          width 100%

      .man
        width 100%
        height 400px
</style>



// WEBPACK FOOTER //
// src/components/WhyChooseUs.vue